import { Selector } from './types';

type InputProps<TestedProp extends PropertyKey, SelectorProps extends Record<TestedProp, unknown>> = Omit<
    SelectorProps,
    TestedProp
> & {
    [key in TestedProp]: SelectorProps[key] | undefined | null;
};

const checkProps = <TestedProp extends PropertyKey, SelectorProps extends Record<TestedProp, unknown>>(
    testedProps: TestedProp[],
    props: InputProps<TestedProp, SelectorProps>
): props is SelectorProps => testedProps.every((prop) => props[prop] !== undefined && props[prop] !== null);

export function ifProps<
    TestedProp extends PropertyKey,
    State,
    SelectorProps extends Record<TestedProp, unknown>,
    Result,
>(
    testedProps: TestedProp[],
    selector: Selector<State, SelectorProps, Result>
): Selector<State, InputProps<TestedProp, SelectorProps>, Result | undefined>;
export function ifProps<
    TestedProp extends PropertyKey,
    State,
    SelectorProps extends Record<TestedProp, unknown>,
    Result,
    DefaultValue,
>(
    testedProps: TestedProp[],
    selector: Selector<State, SelectorProps, Result>,
    defaultValue?: DefaultValue
): Selector<State, InputProps<TestedProp, SelectorProps>, Result | DefaultValue>;
export function ifProps<
    TestedProp extends PropertyKey,
    State,
    SelectorProps extends Record<TestedProp, unknown>,
    Result,
    DefaultValue,
>(
    testedProps: TestedProp[],
    selector: Selector<State, SelectorProps, Result>,
    defaultValue?: DefaultValue
): Selector<State, InputProps<TestedProp, SelectorProps>, Result | DefaultValue | undefined> {
    return (state, props) => (checkProps(testedProps, props) ? selector(state, props) : defaultValue);
}
